// extracted by mini-css-extract-plugin
export default {"img":"Banner_img__rOb9x"};